"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _config = _interopRequireDefault(require("../../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../../KESI2/Stores/DataStore2"));

var _Feature = _interopRequireDefault(require("./Feature"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../common/NavigationManagerCordova"));

var _CourseLoader = _interopRequireDefault(require("../../helpers/CourseLoader"));

var _JSONHelper = _interopRequireWildcard(require("../../helpers/JSONHelper"));

/**
 * This is a very minimalistic approach of a FeatureManager. It has very limited power compared to the old
 * FeatureManager in the native apps.
 *
 * Functions:
 *     - saving user credentials, the activation code and other feature-related metadata
 */
var FeatureManager = /*#__PURE__*/function () {
  function FeatureManager() {
    (0, _classCallCheck2["default"])(this, FeatureManager);
    this.cache = {};
  }

  (0, _createClass2["default"])(FeatureManager, [{
    key: "_getDataPathForFeature",
    value: function _getDataPathForFeature(featureName) {
      return "".concat(_DataStore.DATA_STORE_PATHS.FEATURES, ".").concat(featureName);
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cache = {};
    }
    /**
     *
     * @returns {Array<String>}
     */

  }, {
    key: "getAllFeatureNames",
    value: function getAllFeatureNames() {
      var features = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FEATURES);

      return features ? (0, _keys["default"])(features) : [];
    }
    /**
     *
     * @param featureName
     * @param forceReadingFromStore - otherwise read from cache
     * @returns {Feature}
     */

  }, {
    key: "getFeature",
    value: function getFeature(featureName) {
      var forceReadingFromStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!featureName) {
        return null;
      }

      if (forceReadingFromStore || !this.cache[featureName]) {
        try {
          var json = _DataStore["default"].getElementByPathImmediately(this._getDataPathForFeature(featureName));

          this.cache[featureName] = _Feature["default"].fromJson(json);
        } catch (error) {
          this.cache[featureName] = null;
        }
      }

      return this.cache[featureName];
    }
    /**
     *
     * @param featureName
     * @param forceReadingFromStore - otherwise read from cache
     * @returns {Feature}
     */

  }, {
    key: "getFeatureWaitingForStore",
    value: function () {
      var _getFeatureWaitingForStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(featureName) {
        var forceReadingFromStore,
            json,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                forceReadingFromStore = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

                if (featureName) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", null);

              case 3:
                if (!(forceReadingFromStore || !this.cache[featureName])) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return _DataStore["default"].getElementByPath(this._getDataPathForFeature(featureName));

              case 7:
                json = _context.sent;
                this.cache[featureName] = _Feature["default"].fromJson(json);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                this.cache[featureName] = null;

              case 14:
                return _context.abrupt("return", this.cache[featureName]);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function getFeatureWaitingForStore(_x) {
        return _getFeatureWaitingForStore.apply(this, arguments);
      }

      return getFeatureWaitingForStore;
    }()
    /**
     *
     * @param feature {Feature}
     */

  }, {
    key: "saveFeature",
    value: function () {
      var _saveFeature = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(feature) {
        var featureToSave, existingFeature;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                featureToSave = feature;
                existingFeature = _DataStore["default"].getElementByPathImmediately(this._getDataPathForFeature(feature.name));

                if (existingFeature) {
                  featureToSave = (0, _JSONHelper.addJsonObjects)(existingFeature, feature.toJson());
                } // console.log('saving feature and keeping in cache', JSON.parse(JSON.stringify(featureToSave)))


                this.cache[featureToSave.name] = featureToSave;
                return _context2.abrupt("return", _DataStore["default"].setSingleData(this._getDataPathForFeature(featureToSave.name), featureToSave));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveFeature(_x2) {
        return _saveFeature.apply(this, arguments);
      }

      return saveFeature;
    }()
  }, {
    key: "removeFeature",
    value: function () {
      var _removeFeature = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(feature) {
        var goHome,
            existingFeatures,
            data,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                goHome = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
                _context3.next = 3;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

              case 3:
                existingFeatures = _context3.sent;

                if (!(existingFeatures && existingFeatures[feature])) {
                  _context3.next = 14;
                  break;
                }

                delete existingFeatures[feature];
                data = {};
                data[_DataStore.DATA_STORE_PATHS.FEATURES] = existingFeatures;

                if (feature === _config["default"].kesiMasterFeatureName) {
                  data[_DataStore.DATA_STORE_PATHS.IS_KESI_MASTER] = false;
                }

                _context3.next = 11;
                return _DataStore["default"].setData(data);

              case 11:
                this.clearCache();
                this.cache = existingFeatures;

                if (goHome) {
                  _NavigationManagerCordova["default"].goHome();
                }

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeFeature(_x3) {
        return _removeFeature.apply(this, arguments);
      }

      return removeFeature;
    }()
  }, {
    key: "isChapterActivated",
    value: function () {
      var _isChapterActivated = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(chapterType) {
        var activatedFeatures, courses, chapters, chapter;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                activatedFeatures = this.getAllFeatureNames();
                console.log('isChapterActivated', activatedFeatures);

                if (!_config["default"].useDrupalContent) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 5;
                return _CourseLoader["default"].getChapterByType('equeoqd_menu');

              case 5:
                _context4.t0 = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.next = 10;
                return _CourseLoader["default"].loadHomeCourse();

              case 10:
                _context4.t0 = _context4.sent;

              case 11:
                courses = _context4.t0;
                console.log('isChapterActivated 1', courses);
                chapters = courses.chapters;
                console.log('isChapterActivated 2', courses.chapters);

                if (!(chapters && chapters.length > 0)) {
                  _context4.next = 25;
                  break;
                }

                chapter = chapters.find(function (chapter) {
                  return chapter.type === chapterType;
                });
                console.log('isChapterActivated 3', chapter, activatedFeatures.indexOf(chapter.feature));

                if (!(chapter && activatedFeatures.indexOf(chapter.feature) >= 0)) {
                  _context4.next = 22;
                  break;
                }

                return _context4.abrupt("return", true);

              case 22:
                return _context4.abrupt("return", false);

              case 23:
                _context4.next = 26;
                break;

              case 25:
                return _context4.abrupt("return", false);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function isChapterActivated(_x4) {
        return _isChapterActivated.apply(this, arguments);
      }

      return isChapterActivated;
    }()
  }]);
  return FeatureManager;
}();

var instance = new FeatureManager();
var _default = instance;
exports["default"] = _default;